import { i18n } from "../../next-i18next.config";

/**
 * Longest first, so `en-us` is tried before `en` and `en-us/x` never loses
 * just its `en` (WHO-5766). A stable sort: the six two-letter locales keep
 * their order.
 */
const LOCALES_LONGEST_FIRST = [...i18n.locales].sort(
  (first, second) => second.length - first.length
);

const removeLocaleFromPath = (path: string): string => {
  for (const locale of LOCALES_LONGEST_FIRST) {
    if (path.startsWith(locale)) {
      return path.slice(locale.length);
    } else if (path.startsWith(`/${locale}/`)) {
      return path.slice(locale.length + 1);
    }
  }
  return path;
};

export default removeLocaleFromPath;
